<div class="login_content centered" >

    <div class="mt-5">
        <p class="textCentered">
            Benvenuto nell'applicazione <b>CRI Roadmap</b>! L'app che ti permette di registrare le
            uscite con le auto CRI e i relativi rifornimenti di carburante.
        </p>
    </div>
    <h6 style="text-align: center;">
        Per eventuali segnalazioni di tipo tecnico contattare <b>roadmap@cri.it</b>
    </h6>
    <button type="button" (click)="logIn()" class="btn btn-primary btn-block mt-5"> LOGIN CON GAIA </button>

</div>


